import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import SublocationApiUrls from 'src/apiUrls/SublocationApiUrls'
import React from 'react'
import SublocationKeys from 'src/constants/locale/key/Sublocation'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.SUBLOCATION
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let sublocationCode = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: sublocationCode
      }
    )
    let intlcode = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.INTLCODE
    )
    let active = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.ACTIVE
    )
    let language = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.LANGUAGE
    )
    let indicator = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.INDICATOR
    )
    let address = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.ADDRESS
    )
    let descriptionEn = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.DESCRIPTION_EN
    )
    let code = translate(
      Namespace.SUBLOCATION,
      SublocationKeys.CODE
    )

    return {
      sublocationCode,
      tableTitle,
      intlcode,
      active,
      language,
      indicator,
      address,
      descriptionEn,
      code
    }
  }

  const columns = [
    {
      field: "intlcode",
      title: translatedTextsObject.intlcode,
    },
    {
      field: "indicator",
      title: translatedTextsObject.indicator,
    },
    {
      field: "code",
      title: translatedTextsObject.code,
    },
    {
      field: "descriptionEn",
      title: translatedTextsObject.descriptionEn,
    },
    {
      field: "active",
      title: translatedTextsObject.active,
      type: 'boolean'
    },
    {
      field: "address",
      title: translatedTextsObject.address,
    },
    {
      field: "language",
      title: translatedTextsObject.language,
    }
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: SublocationApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              //exportData={{ url: SublocationApiUrls.EXPORT }}
              fetch={{ url: SublocationApiUrls.GET }}
              idAccessor="id"
              notification={notification}
              fetchCustomData={{ codeMType: "Sublocation" }}
              //tableConfigurationCode="REPLACE_WITH_CORE_TABLE_CONFIG_CODE"
              viewRoute={`${pathname}/view`}
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 500, 1000]
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
